
define('modules/application/wizard/steps/zoneStep',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "./regularStep",
  "./zoneStep/zonesMenuView",
  "./zoneStep/zoneDetailView",
  "./zoneStep/zoneModel",
  "./zoneStep/zoneCollection"
],

function(
  app,
  Backbone,
  jQueryUi,
  RegularStep,
  ZonesMenuView,
  ZoneDetailView,
  ZoneModel,
  ZoneCollection) {

  //Creating an event aggragatop
  var ZonesEventAggregator    = _.extend({}, Backbone.Events);

  //Extending regularStep views
  var ZoneStepViews           = _.extend({},RegularStep.Views);
  ZoneStepViews.Content       = ZoneStepViews.Content.extend({
      template     : "application/wizard/steps/zones",
      events       : {
        "click #addZone"      :  "addZone",
        "click #duplicateZone":  "duplicateZone",
        "click #deleteZone"   :  "deleteSelectedZone"
      },

      addConstructors                  : function() {
        //Adding subviews constructor
        this.ZonesMenuView   = ZonesMenuView;
        this.ZoneDetailView  = ZoneDetailView;
      },

      initialize                      : function() {
        this.addConstructors();
        var that = this;

        window.BticinoS4B.eventAggregator.unbind("zone:selected",           this.zoneSelectedEventHandler);
        window.BticinoS4B.eventAggregator.bind("zone:selected",             this.zoneSelectedEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("zone:selectionRequested", this.zoneSelectionRequestedEventHandler);
        window.BticinoS4B.eventAggregator.bind("zone:selectionRequested",   this.zoneSelectionRequestedEventHandler, this);

        this.model.set("sortable", true);
        this.insertView(".menu",new this.ZonesMenuView({ model : this.model, stepEventAggregator : this.options.stepEventAggregator}));
      },

      zoneSelectionRequestedEventHandler         : function(zoneNumber)   {
        var selectedModel = _.filter(this.model.collection.models, function(zone) {
          return zone.get("number")==zoneNumber;
        });

        if (selectedModel.length===1)
          selectedModel = selectedModel[0];
        else {
          if (this.model.additionalZones)
            selectedModel = _.filter(this.model.additionalZones, function(zone) {
              if (zone.attributes)
                return zone.get("number")==zoneNumber;
              else
                return undefined;
            });

          if (selectedModel.length===1)
            selectedModel = selectedModel[0];
          else
            selectedModel = undefined;
        }

        if (selectedModel)
          this.setSelectedZone(selectedModel);
      },

      zoneSelectedEventHandler                   : function(selectedView) {
        var isPartOfACollection = selectedView.model.get("number")>0;
        if (isPartOfACollection)
          this.showCommands();
        else
          this.hideCommands();
        this.setSelectedZone(selectedView.model);
      },

      showCommands                               : function() {
        this.$el.find(".commands").show();
      },

      hideCommands                               : function() {
        this.$el.find(".commands").hide();
      },

      setSelectedZone                            : function(newModel) {
        var zoneDetail = new this.ZoneDetailView({
          model               : _.extend({stepEventAggregator : this.options.stepEventAggregator}, newModel),
          sections            : this.model.get("sections")
        });

        this.setView(".detail", zoneDetail).render();
      },

      addZone                                    : function() {
        this.model.addZone(null);
      },

      duplicateZone                              : function() {
        this.model.duplicateSelectedZone();
      },

      deleteSelectedZone                         : function() {

        var confirmed=confirm($.i18n._("IDS_WTR1001_9011"));
        if (confirmed) {
          //Searching selected zone
          var selectedZone  = this.model.collection.filter(function(model){
            return model.get("selected")===true;
          });

          if ((this.model.collection.length>1)&&(selectedZone!==null)) {
            this.deleteZone(selectedZone[0]);
          }
          else
            alert($.i18n._("IDS_W1_9089"));
        }
      },

      deleteZone                                 : function(zoneToDelete) {
        this.model.removeZone(zoneToDelete);
        this.model.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
      },

      onClose                                    : function() {
        window.BticinoS4B.eventAggregator.unbind("zone:selected");
        window.BticinoS4B.eventAggregator.unbind("zone:selectionRequested");
      }
  });

  var ZonesModel              = Backbone.Model.extend({

    addConstructors                     : function() {
      this.ZoneModel      = ZoneModel;
      this.ZoneCollection = ZoneCollection;
    },

    initialize                          : function() {
      this.addConstructors();
      window.BticinoS4B.eventAggregator.unbind("mainControlUnit:selected",           this.mainControlUnitSelectedEventHandler);
      window.BticinoS4B.eventAggregator.bind("mainControlUnit:selected",             this.mainControlUnitSelectedEventHandler, this);

      window.BticinoS4B.eventAggregator.unbind("mainControlUnit:removed",            this.mainControlUnitRemovedEventHandler);
      window.BticinoS4B.eventAggregator.bind("mainControlUnit:removed",              this.mainControlUnitRemovedEventHandler, this);

      this.get("stepEventAggregator").unbind('collection:validated',   this.collectionValidatedEventHandler);
      this.get("stepEventAggregator").bind('collection:validated',     this.collectionValidatedEventHandler, this);

      this.get("stepEventAggregator").unbind('collection:unvalidated', this.collectionUnvalidatedEventHandler);
      this.get("stepEventAggregator").bind('collection:unvalidated',   this.collectionUnvalidatedEventHandler, this);

      //Bind on materials overview model delivery request
      window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",               this.deliverModel);
      window.BticinoS4B.eventAggregator.bind("modelDeliver:request",                 this.deliverModel, this);

      window.BticinoS4B.eventAggregator.unbind("load:Project",                       this.loadProject);
      window.BticinoS4B.eventAggregator.bind("load:Project",                         this.loadProject, this);

      window.BticinoS4B.eventAggregator.unbind("mainControlUnit:chosen",             this.mainControlUnitChosenEventHandler);
      window.BticinoS4B.eventAggregator.bind("mainControlUnit:chosen",               this.mainControlUnitChosenEventHandler, this);

      this.instanceCollection();
    },

    collectionValidatedEventHandler     : function() {
      this.get("stepEventAggregator").trigger("step:validated", this);
    },

    collectionUnvalidatedEventHandler   : function() {
      this.get("stepEventAggregator").trigger("step:unvalidated", this);
    },

    instanceCollection                  : function() {
      this.collection = new this.ZoneCollection([], {stepEventAggregator:this.get("stepEventAggregator")});
      this.addZone(null);
      this.get("stepEventAggregator").trigger("collection:initialized");
    },

    deliverModel                        : function() {
      switch (BticinoS4B.vars.system.id) {
        case '#2':
          BticinoS4B.solution.thermoregulation.zones = this;
          break;
        case '#4':
          BticinoS4B.solution.intrusionDetection.zones = this;
          break;
        case '#5+6':
          BticinoS4B.solution.audioVideo.zones = this;
          break;
        case '#13+20':
          BticinoS4B.solution.automation.zones = this;
          break;
        case '#13':
          BticinoS4B.solution.automationSimple.zones = this;
          break;
        case '#21':
          BticinoS4B.solution.energyManagement.zones = this;
          break;
      }
      BticinoS4B.Instances.Models.ApplicationModel.set("zones", this);
    },

    addZone                             : function(newModel) {
      var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;
      if (this.collection.length<maxZoneNumber) {
        if (newModel===null)
          this.collection.add(new this.ZoneModel({
            number              : this.collection.length>0 ? this.collection.models[this.collection.length-1].get("number")+1: this.collection.length+1,
            name                : "{defaultName} "+(this.collection.length+1),
            stepEventAggregator : this.get("stepEventAggregator"),
            zoneEventAggregator : _.extend({}, Backbone.Events)
          }));
        else
          this.collection.add(newModel);

        this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
        BticinoS4B.Instances.Models.ApplicationModel.set("zoneLength", this.collection.length);
      }
      else {
        alert($.i18n._("IDS_W1_9090"));
      }
    },

    loadZone                            : function(newModel) {
      var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;
      if (this.collection.length<maxZoneNumber) {
        var zoneToLoad = new this.ZoneModel(_.extend({
          stepEventAggregator : this.get("stepEventAggregator"),
          zoneEventAggregator : _.extend({}, Backbone.Events)
        }, newModel));

        this.collection.add(zoneToLoad);
      }
    },

    removeZone                          : function(zoneToRemove, _force) {
      var force = false;
      if (_force)
        force = _false;

      if (zoneToRemove.isRemovable() || force)
        this.collection.remove(zoneToRemove);
      else
        alert("This zone cannot be removed because it contains elements from other sections. Please review your choices and retry");
    },

    loadProject                         : function(model) {
      this.collection = new this.ZoneCollection([], {stepEventAggregator:this.get("stepEventAggregator")});
      if(model.zones){
        for (var i=0; i<model.zones.length; i++)
        {
          this.loadZone(model.zones[i]);
        }

        this.get("stepEventAggregator").trigger("zone:loaded");
        this.get("stepEventAggregator").trigger("render:requested");
      }
    }
  });

  //Creating final ZoneStep class
  var ZoneStep                = _.extend({}, RegularStep, {
    objClass      : "zones",
    Views         : ZoneStepViews,
    Model         : ZonesModel
  });


  // Required, return the module for AMD compliance
  return ZoneStep;

});